import { Action } from 'redux';

import { SetVizPathActionType } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';

export interface SetVizPathAction extends Action {
  vizPath: string;
}

export function setVizPath(vizPath: string): SetVizPathAction {
  return {
    type: SetVizPathActionType,
    vizPath
  };
}

export const isSetVizPathAction = isActionFactory<SetVizPathAction>(SetVizPathActionType);
